@if (isDesktop) {
  <div class="modal-backdrop" (click)="onBackdropClick($event)" aria-hidden="true"></div>
  <div class="modal-desktop" role="dialog" aria-modal="true" [attr.aria-labelledby]="'desktop-modal-title-' + modal().id">
    <header class="header">
      <div class="toolbar">
        <div class="content">
          <div class="title-group">
            <h1 class="title" [id]="'desktop-modal-title-' + modal().id">{{ modal().title ?? '' }}</h1>
            @if (modal().badge; as badge) {
              <div class="badge">
                @if (badge.icon) {
                  <img class="badge-icon" [src]="'assets/icons/' + badge.icon + '.svg'" [alt]="'Ícono de ' + badge.label">
                }
                <span class="badge-label">{{ badge.label }}</span>
              </div>
            }
          </div>
          <img class="icon" src="assets/icons/cross.svg" alt="Cerrar" role="button" tabindex="0" (click)="close()" (keydown.enter)="close()" (keydown.space)="close()" />
        </div>
      </div>
    </header>
    <div class="main-content-wrapper">
      <div class="main-content">
        <ng-container *ngComponentOutlet="modal().component; inputs: modal().inputs"></ng-container>
      </div>
    </div>
  </div>
}
<ion-modal class="modal-mobile" [breakpoints]="[0, 1]" [initialBreakpoint]="1" [isOpen]="!isDesktop" (willDismiss)="onMobileWillDismiss()">
  <ng-template>
    <ion-header class="header">
      <ion-toolbar class="toolbar">
        <div class="content">
          <div class="title-group">
            <h1 class="title">{{ modal().title ?? '' }}</h1>
            @if (modal().badge; as badge) {
              <div class="badge">
                @if (badge.icon) {
                  <img class="badge-icon" [src]="'assets/icons/' + badge.icon + '.svg'" [alt]="'Ícono de ' + badge.label">
                }
                <span class="badge-label">{{ badge.label }}</span>
              </div>
            }
          </div>
          <img class="icon" src="assets/icons/cross.svg" alt="Cerrar" (click)="close()" (keyup.enter)="close()" tabindex="0" />
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="main-content">
        <ng-container *ngComponentOutlet="modal().component; inputs: modal().inputs"></ng-container>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
